
import React from 'react';
import { ImageOff } from 'lucide-react';

const NoImagesFallback = () => {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-muted/20 rounded-lg border border-dashed border-muted-foreground/30 h-64">
      <ImageOff className="h-12 w-12 text-muted-foreground opacity-40 mb-4" />
      <h3 className="text-lg font-medium text-muted-foreground">No images available</h3>
      <p className="text-sm text-muted-foreground/70 text-center mt-2 max-w-md">
        This portfolio item doesn't have any images attached to it.
      </p>
    </div>
  );
};

export default NoImagesFallback;
